<div class="dplayer-mask"></div>
<div class="dplayer-video-wrap">
    <div class="dplayer-video-wrap-aspect">
      {{ include './video.art' video }}
    </div>
    {{ if options.logo }}
    <div class="dplayer-logo">
        <img src="{{ options.logo }}">
    </div>
    {{ /if }}
    <div class="dplayer-danmaku"{{ if options.danmaku && options.danmaku.bottom }} style="margin-bottom:{{ options.danmaku.bottom }}"{{ /if }}>
        <div class="dplayer-danmaku-item dplayer-danmaku-item--demo"></div>
    </div>
    <div class="dplayer-subtitle"></div>
    <div class="dplayer-bezel">
        <span class="dplayer-bezel-icon"></span>
        {{ if options.danmaku }}
        <span class="dplayer-danloading">{{ tran('Danmaku is loading') }}</span>
        {{ /if }}
        <span class="dplayer-loading-icon">{{@ icons.loading }}</span>
    </div>
</div>
<div class="dplayer-controller-mask"></div>
<div class="dplayer-controller">
    <div class="dplayer-icons dplayer-comment-box">
        <button class="dplayer-icon dplayer-comment-setting-icon" aria-label="{{ tran('Setting') }}" data-balloon-nofocus data-balloon-pos="up">
            <span class="dplayer-icon-content">{{@ icons.pallette }}</span>
        </button>
        <input class="dplayer-comment-input" type="search" placeholder="{{ tran('Input danmaku, hit Enter') }}" spellcheck="false" maxlength="60">
        <button class="dplayer-icon dplayer-send-icon" aria-label="{{ tran('Send') }}" data-balloon-nofocus data-balloon-pos="up">
            <span class="dplayer-icon-content">{{@ icons.send }}</span>
        </button>
    </div>
    <div class="dplayer-icons dplayer-icons-left">
        <button class="dplayer-icon dplayer-play-icon">
            <span class="dplayer-icon-content">{{@ icons.play }}</span>
        </button>
        <div class="dplayer-volume">
            <button class="dplayer-icon dplayer-volume-icon">
                <span class="dplayer-icon-content">{{@ icons.volumeDown }}</span>
            </button>
            <div class="dplayer-volume-bar-wrap" data-balloon-nofocus data-balloon-pos="up">
                <div class="dplayer-volume-bar">
                    <div class="dplayer-volume-bar-inner" style="background: {{ options.theme }};">
                        <span class="dplayer-thumb" style="background: {{ options.theme }};"></span>
                    </div>
                </div>
            </div>
        </div>
        <span class="dplayer-time">
            <span class="dplayer-ptime">00:00</span> /
            <span class="dplayer-dtime">00:00</span>
        </span>
        {{ if options.live }}
        <span class="dplayer-live-badge" aria-label="{{ tran('Synchronize') }}" data-balloon-nofocus data-balloon-pos="up">
            <span class="dplayer-icon-content">
                <span class="dplayer-live-dot" style="background: {{ options.theme }};"></span>{{ tran('Live') }}
            </span>
        </span>
        {{ /if }}
    </div>
    <div class="dplayer-icons dplayer-icons-right">
        {{ if options.screenshot }}
        <div class="dplayer-icon dplayer-camera-icon" aria-label="{{ tran('Screenshot') }}" data-balloon-nofocus data-balloon-pos="up">
            <span class="dplayer-icon-content">{{@ icons.camera }}</span>
        </div>
        {{ /if }}
        {{ if options.airplay }}
        <div class="dplayer-icon dplayer-airplay-icon" aria-label="{{ tran('AirPlay') }}" data-balloon-nofocus data-balloon-pos="up">
            <span class="dplayer-icon-content">{{@ icons.airplay }}</span>
        </div>
        {{ /if }}
        <div class="dplayer-comment">
            <button class="dplayer-icon dplayer-comment-icon" aria-label="{{ tran('Send danmaku') }}" data-balloon-nofocus data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.comment }}</span>
            </button>
        </div>
        {{ if options.subtitle }}
        <div class="dplayer-subtitle-btn">
            <button class="dplayer-icon dplayer-subtitle-icon" aria-label="{{ tran('Hide subtitle') }}" data-balloon-nofocus data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.subtitle }}</span>
            </button>
        </div>
        {{ /if }}
        <div class="dplayer-setting">
            <button class="dplayer-icon dplayer-setting-icon" aria-label="{{ tran('Setting') }}" data-balloon-nofocus data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.setting }}</span>
            </button>
        </div>
        <div class="dplayer-full">
            <button class="dplayer-icon dplayer-pip-icon" aria-label="{{ tran('Picture-in-Picture') }}" data-balloon-nofocus data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.pip }}</span>
            </button>
            <button class="dplayer-icon dplayer-full-in-icon" aria-label="{{ tran('Web full screen') }}" data-balloon-nofocus data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.fullWeb }}</span>
            </button>
            <button class="dplayer-icon dplayer-full-icon" aria-label="{{ tran('Full screen') }}" data-balloon-nofocus data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.full }}</span>
            </button>
        </div>
    </div>
    <div class="dplayer-bar-wrap">
        <div class="dplayer-bar-time hidden">00:00</div>
        <div class="dplayer-bar-preview"></div>
        <div class="dplayer-bar">
            <div class="dplayer-loaded" style="width: 0;"></div>
            <div class="dplayer-played" style="width: 0; background: {{ options.theme }};">
                <span class="dplayer-thumb" style="background: {{ options.theme }};"></span>
            </div>
        </div>
    </div>
</div>
<div class="dplayer-setting-box" style="{{ options.video.quality ? `--quality-length:${options.video.quality.length}` : '' }}">
    <div class="dplayer-setting-origin-panel">
        {{ if options.video.quality }}
        <div class="dplayer-setting-item dplayer-setting-quality">
            <span class="dplayer-label">{{ tran('Quality') }}</span>
            <span class="dplayer-label-value">{{ options.video.quality[options.video.defaultQuality].name }}</span>
            <div class="dplayer-toggle">{{@ icons.right }}</div>
        </div>
        {{ /if }}
        <div class="dplayer-setting-item dplayer-setting-audio">
            <span class="dplayer-label">{{ tran('Audio') }}</span>
            <span class="dplayer-label-value">{{ tran('Primary audio') }}</span>
            <div class="dplayer-toggle">{{@ icons.right }}</div>
        </div>
        <div class="dplayer-setting-item dplayer-setting-speed">
            <span class="dplayer-label">{{ tran('Speed') }}</span>
            <span class="dplayer-label-value">{{ tran('Normal') }}</span>
            <div class="dplayer-toggle">{{@ icons.right }}</div>
        </div>
        <div class="dplayer-setting-item dplayer-setting-loop">
            <span class="dplayer-label">{{ tran('Loop') }}</span>
            <div class="dplayer-toggle">
                <input class="dplayer-toggle-setting-input" type="checkbox" name="dplayer-toggle">
                <label for="dplayer-toggle" style="--theme-color:{{ options.theme }}"></label>
            </div>
        </div>
        <div class="dplayer-setting-item dplayer-setting-showdan">
            <span class="dplayer-label">{{ tran('Show danmaku') }}</span>
            <div class="dplayer-toggle">
                <input class="dplayer-showdan-setting-input" type="checkbox" name="dplayer-toggle-dan">
                <label for="dplayer-toggle-dan" style="--theme-color:{{ options.theme }}"></label>
            </div>
        </div>
        <div class="dplayer-setting-item dplayer-setting-danunlimit">
            <span class="dplayer-label">{{ tran('Unlimited danmaku') }}</span>
            <div class="dplayer-toggle">
                <input class="dplayer-danunlimit-setting-input" type="checkbox" name="dplayer-toggle-danunlimit">
                <label for="dplayer-toggle-danunlimit" style="--theme-color:{{ options.theme }}"></label>
            </div>
        </div>
        <div class="dplayer-setting-item dplayer-setting-danmaku">
            <span class="dplayer-label">{{ tran('Opacity for danmaku') }}</span>
            <span class="dplayer-label-value">1.0</span>
            <div class="dplayer-danmaku-bar-wrap">
                <div class="dplayer-danmaku-bar">
                    <div class="dplayer-danmaku-bar-inner" style="background: {{ options.theme }};">
                        <span class="dplayer-thumb" style="background: {{ options.theme }};"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {{ if options.video.quality }}
    <div class="dplayer-setting-quality-panel">
        <div class="dplayer-setting-header dplayer-setting-quality-header">
            <div class="dplayer-toggle">{{@ icons.left }}</div>
            <span class="dplayer-label">{{ tran('Quality') }}</span>
        </div>
        {{ each options.video.quality }}
            <div class="dplayer-setting-quality-item {{ $value.name === options.video.quality[options.video.defaultQuality].name ? 'dplayer-setting-quality-current' : '' }}" data-index="{{ $index }}">
                <div class="dplayer-toggle">{{@ icons.check }}</div>
                <span class="dplayer-label">{{ $value.name }}</span>
            </div>
        {{ /each }}
    </div>
    {{ /if }}
    <div class="dplayer-setting-speed-panel">
        <div class="dplayer-setting-header dplayer-setting-speed-header">
            <div class="dplayer-toggle">{{@ icons.left }}</div>
            <span class="dplayer-label">{{ tran('Speed') }}</span>
        </div>
        {{ each options.playbackSpeed }}
            <div class="dplayer-setting-speed-item {{ $value === 1 ? 'dplayer-setting-speed-current' : '' }}" data-speed="{{ $value }}">
                <div class="dplayer-toggle">{{@ icons.check }}</div>
                <span class="dplayer-label">{{ $value === 1 ? tran('Normal') : $value }}</span>
            </div>
        {{ /each }}
    </div>
    <div class="dplayer-setting-audio-panel">
        <div class="dplayer-setting-header dplayer-setting-audio-header">
            <div class="dplayer-toggle">{{@ icons.left }}</div>
            <span class="dplayer-label">{{ tran('Audio') }}</span>
        </div>
        <div class="dplayer-setting-audio-item dplayer-setting-audio-current" data-audio="primary">
            <div class="dplayer-toggle">{{@ icons.check }}</div>
            <span class="dplayer-label">{{ tran('Primary audio') }}</span>
        </div>
        <div class="dplayer-setting-audio-item" data-audio="secondary">
            <div class="dplayer-toggle">{{@ icons.check }}</div>
            <span class="dplayer-label">{{ tran('Secondary audio') }}</span>
        </div>
    </div>
</div>
<div class="dplayer-comment-setting-box">
    <div class="dplayer-comment-setting-color">
        <div class="dplayer-comment-setting-title">{{ tran('Set danmaku color') }}</div>
        <div class="dplayer-comment-setting-color-list">
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#ffeaea" checked>
                <span style="background: #ffeaea"></span>
            </label>
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#f02840">
                <span style="background: #f02840"></span>
            </label>
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#fd7e80">
                <span style="background: #fd7e80"></span>
            </label>
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#fda708">
                <span style="background: #fda708"></span>
            </label>
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#ffe133">
                <span style="background: #ffe133"></span>
            </label>
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#64dd17">
                <span style="background: #64dd17"></span>
            </label>
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#00d4f5">
                <span style="background: #00d4f5"></span>
            </label>
            <label>
                <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#4763ff">
                <span style="background: #4763ff"></span>
            </label>
        </div>
    </div>
    <div class="dplayer-comment-setting-type">
        <div class="dplayer-comment-setting-title">{{ tran('Set danmaku type') }}</div>
        <label>
            <input type="radio" name="dplayer-danmaku-type-{{ index }}" value="top">
            <span>{{ tran('Top') }}</span>
        </label>
        <label>
            <input type="radio" name="dplayer-danmaku-type-{{ index }}" value="right" checked>
            <span>{{ tran('Rolling') }}</span>
        </label>
        <label>
            <input type="radio" name="dplayer-danmaku-type-{{ index }}" value="bottom">
            <span>{{ tran('Bottom') }}</span>
        </label>
    </div>
    <div class="dplayer-comment-setting-size">
        <div class="dplayer-comment-setting-title">{{ tran('Set danmaku size') }}</div>
        <label>
            <input type="radio" name="dplayer-danmaku-size-{{ index }}" value="big">
            <span>{{ tran('Big') }}</span>
        </label>
        <label>
            <input type="radio" name="dplayer-danmaku-size-{{ index }}" value="medium" checked>
            <span>{{ tran('Medium') }}</span>
        </label>
        <label>
            <input type="radio" name="dplayer-danmaku-size-{{ index }}" value="small">
            <span>{{ tran('Small') }}</span>
        </label>
    </div>
</div>
<div class="dplayer-info-panel dplayer-info-panel-hide">
    <div class="dplayer-info-panel-close">[x]</div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-version">
        <span class="dplayer-info-panel-item-title">Player Version</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-mimetype">
        <span class="dplayer-info-panel-item-title">Mime Type</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-video-fps">
        <span class="dplayer-info-panel-item-title">Video FPS</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-page-fps">
        <span class="dplayer-info-panel-item-title">Page FPS</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-dropped-frames">
        <span class="dplayer-info-panel-item-title">Dropped Frames</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-type">
        <span class="dplayer-info-panel-item-title">Video Type</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-url">
        <span class="dplayer-info-panel-item-title">Video URL</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-resolution">
        <span class="dplayer-info-panel-item-title">Video Resolution</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-duration">
        <span class="dplayer-info-panel-item-title">Video Duration</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-buffer-remain">
        <span class="dplayer-info-panel-item-title">Buffer Remain</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-download-speed">
        <span class="dplayer-info-panel-item-title">Download Speed</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
</div>
<div class="dplayer-menu">
    {{ each options.contextmenu }}
        <div class="dplayer-menu-item">
            <a{{ if $value.link }} target="_blank"{{ /if }} href="{{ $value.link || 'javascript:void(0);' }}">{{ tran($value.text) }}</a>
        </div>
    {{ /each }}
</div>
<div class="dplayer-notice"></div>
<div class="dplayer-mobile-icon-wrap">
    <button class="dplayer-mobile-icon dplayer-mobile-icon-backward">
        {{@ icons.backward }}
    </button>
    <button class="dplayer-mobile-icon dplayer-mobile-icon-play">
        {{@ icons.play }}
    </button>
    <button class="dplayer-mobile-icon dplayer-mobile-icon-forward">
        {{@ icons.forward }}
    </button>
</div>
